import type { PortableTextComponents } from '@portabletext/react';
import { Link } from 'react-router';
import { urlFor } from './utils';

export const portableTextComponents: PortableTextComponents = {
  block: {
    'body-sm': ({ children }) => <p className="body-sm">{children}</p>,
    'body-md': ({ children }) => <p className="body-md">{children}</p>,
    'body-reg': ({ children }) => <p className="body-reg">{children}</p>,
    blockquote: ({ children }) => (
      <blockquote className="border-l-4 border-gray-300 pl-4 italic">{children}</blockquote>
    ),
    h1: ({ children }) => <h1 className="headline-lg">{children}</h1>,
    h2: ({ children }) => <h2 className="headline">{children}</h2>,
    h3: ({ children }) => <h3 className="sub-lg">{children}</h3>,
    h4: ({ children }) => <h4 className="sub-md">{children}</h4>,
    headline: ({ children }) => <p className="headline">{children}</p>,
    'headline-lg': ({ children }) => <p className="headline-lg">{children}</p>,
    normal: ({ children }) => {
      // Check if the block is empty (line break)
      if (Array.isArray(children) && children.length === 1 && children[0] === '') {
        return <br />;
      }
      return <p>{children}</p>;
    },
    sub: ({ children }) => <p className="sub">{children}</p>,
    'sub-lg': ({ children }) => <p className="sub-lg">{children}</p>,
    'sub-md': ({ children }) => <p className="sub-md">{children}</p>,
    'sub-sm': ({ children }) => <p className="sub-sm">{children}</p>,
  },
  list: {
    bullet: ({ children }) => <ul className="list-disc space-y-2 pl-6">{children}</ul>,
    number: ({ children }) => <ol className="list-decimal space-y-2 pl-6">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => <li className="body-reg list-disc space-y-2 pl-2">{children}</li>,
    number: ({ children }) => <li className="body-reg list-decimal space-y-2 pl-2">{children}</li>,
  },
  marks: {
    em: ({ children }) => <em className="italic">{children}</em>,
    link: ({ children, value }) => {
      const href = value?.href || '';
      const isExternal = href.startsWith('http');

      if (isExternal) {
        return (
          <a
            className="underline hover:opacity-50"
            href={href}
            rel="noopener noreferrer"
            target="_blank"
          >
            {children}
          </a>
        );
      }

      return (
        <Link className="text-blue-600 underline hover:text-blue-800" to={href}>
          {children}
        </Link>
      );
    },
    strong: ({ children }) => <strong className="font-bold">{children}</strong>,
  },
  types: {
    image: ({ value }) => {
      if (!value?.asset) return null;

      const imageUrl = urlFor(value).width(800).url();

      return (
        <div className="my-6">
          <img alt={value.alt || ''} className="rounded-lg" src={imageUrl} />
        </div>
      );
    },
  },
};

